import { tokens } from "styles/Tokens";
import { engagementTypes } from "utils/Types";

export const getColor = (status: string) => {
  let color = tokens.Text.Feedback.Alert;
  if (status === engagementTypes.active) {
    color = tokens.Text.Feedback.Done;
  }
  if (status === engagementTypes.overdue) {
    color = tokens.Text.Feedback.Overdue;
  }
  return color;
};

export const abovePropertyHeader = [
  { content: "Property" },
  { content: "Inncode" },
  { content: "Brand" },
  { content: "Leader Plans" },
  { content: "Team Plans" },
  { content: "Engagement" },
  { content: "" }
];
